<template>
    <v-form ref="form" @submit="submit" v-model="formValid" class="call-configs">
        <div class="title-config">
            <div class="title">{{ $f.tc('campaignInfo') }}</div>
            <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
        </div>
        <div class="fci-scrollbar config-content">
            <div class="label">{{ $f.tc('title') }}</div>
            <v-text-field
                v-model="model.title"
                :rules="formRules.required"
                class="input-custom"
            ></v-text-field>
            <div v-if="typeOfScenario==='bot'">
                <div class="label mt-12">{{ $f.tc('currentBot') }}</div>
                <div class="display-flex align-center">
                    <v-text-field
                        disabled hide-details
                        v-model="currentBotName"
                        class="input-custom"
                    ></v-text-field>
                    <div class="btn-custom btn-checkout" @click="goToScenario(campaign.bot.id)">
                        <img
                            src="/img/checkout-blue.svg"
                            style="transform: scale(0.95); margin-right: 6px"
                            alt="icon-checkout-bot"
                        />
                        {{ $f.tc('bot') }}
                    </div>
                    <div class="btn-custom btn-checkout" @click="goToNLP(campaign.bot.id)">
                        <img
                            src="/img/checkout-blue.svg"
                            style="transform: scale(0.95); margin-right: 6px"
                            alt="icon-checkout-nlp"
                        />
                        {{ $f.tc('nlp') }}
                    </div>
                </div>
                <div class="label mt-12">{{ isAdmin() ? $f.tc('bot') : $f.tc('template') }}</div>
                <div class="display-flex align-center">
                    <v-autocomplete
                        v-model="model.bot"
                        :items="botList"
                        :rules="formRules.required"
                        item-text="text"
                        item-value="value"
                        class="input-custom"
                    ></v-autocomplete>
                    <div class="btn-custom btn-checkout" @click="goToScenario(model.bot)">
                        <img
                            src="/img/checkout-blue.svg"
                            style="transform: scale(0.95); margin-right: 6px"
                            alt="icon-checkout-bot-1"
                        />
                        {{ $f.tc('bot') }}
                    </div>
                    <div class="btn-custom btn-checkout" @click="goToNLP(model.bot)">
                        <img
                            src="/img/checkout-blue.svg"
                            style="transform: scale(0.95); margin-right: 6px"
                            alt="icon-checkout-nlp-1"
                        />
                        {{ $f.tc('nlp') }}
                    </div>
                </div>
            </div>
            <div v-else-if="typeOfScenario==='tova'">
                <div class="label mt-12">{{ $f.tc('currentTovaAgent') }}</div>
                <div class="display-flex align-center">
                    <v-text-field
                        disabled hide-details
                        v-model="currentTovaAgentName"
                        class="input-custom"
                    ></v-text-field>
                    <div class="btn-custom btn-checkout" @click="goToScenario(campaign.tova_agent.id)">
                        <img
                            src="/img/checkout-blue.svg"
                            style="transform: scale(0.95); margin-right: 6px"
                            alt="icon-checkout-bot"
                        />
                        {{ $f.tc('tova') }}
                    </div>
                </div>
                <div class="label mt-12">{{ isAdmin() ? $f.tc('tova') : $f.tc('template') }}</div>
                <div class="display-flex align-center">
                    <v-autocomplete
                        v-model="model.tova_agent"
                        :items="tovaAgentList"
                        :rules="formRules.required"
                        item-text="text"
                        item-value="value"
                        class="input-custom"
                    ></v-autocomplete>
                    <div class="btn-custom btn-checkout" @click="goToTovaAgent(model.tova_agent)">
                        <img
                            src="/img/checkout-blue.svg"
                            style="transform: scale(0.95); margin-right: 6px"
                            alt="icon-checkout-bot-1"
                        />
                        {{ $f.tc('tova') }}
                    </div>
                </div>
            </div>
            <div v-else-if="typeOfScenario==='agent'">
                <div class="label mt-12">{{ $f.tc('currentAgent') }}</div>
                <div class="display-flex align-center">
                    <v-text-field
                        disabled hide-details
                        v-model="currentAgentId"
                        class="input-custom"
                    ></v-text-field>
                </div>
                <div class="label mt-12">{{ isAdmin() ? $f.tc('agent') : $f.tc('template') }}</div>
                <div class="display-flex align-center">
                    <v-text-field
                        v-model="model.agent_id"
                        :rules="formRules.required"
                        class="input-custom"
                    ></v-text-field>
                </div>
            </div>
            <div v-else-if="typeOfScenario==='flow'">
                <div class="label mt-12">{{ $f.tc('currentVoiceAgentMultiAgent') }}</div>
                <div class="display-flex align-center">
                    <v-text-field
                        disabled hide-details
                        v-model="currentFlowId"
                        class="input-custom"
                    ></v-text-field>
                </div>
                <div class="label mt-12">{{ isAdmin() ? $f.tc('voiceAgentMultiAgent') : $f.tc('template') }}</div>
                <div class="display-flex align-center">
                    <v-text-field
                        v-model="model.flow_id"
                        :rules="formRules.required"
                        class="input-custom"
                    ></v-text-field>
                </div>
            </div>
            <div>
                <div class="label mt-12">{{ $f.tc('script') }}</div>
                <v-select
                    v-model="currentScript"
                    :items="campaign.freeswitch_scripts"
                    :rules="formRules.required"
                    item-text="name"
                    class="input-custom"
                    return-object
                ></v-select>
                <div class="display-flex mt-12">
                    <div class="label">{{ $f.tc('currentScript') }}</div>
                    <div class="mb-6 ml-6" style="margin-top: 1px !important;">{{ campaign.script }}</div>
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import CampaignService from '@/services/campaign.service'
import {mapState} from 'vuex'
import ScenarioService from '@/services/scenario.service'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import lodash from 'lodash'
import AgentService from '@/services/agent.service'

const defaultModel = {
    title: '',
    bot: null,
    tova_agent: null,
    agent_id: '',
    flow_id: '',
}

export default {
    name: 'CampaignInfoConfig2',
    mixins: [FormMixin, RoleMixin],
    data() {
        return {
            typeOfScenario: 'bot',
            //use bot
            currentBotName: '',
            oldModel: null,
            scenarioList: [],
            botList: [],
            model: this.$utils.cloneObject(defaultModel),
            // use tova agent
            currentTovaAgentName: '',
            tovaAgentList: [],
            // use voice agent
            currentAgentId: '',
            // use voice flow
            currentFlowId: '',
            currentScript: {},
            oldScript: '',
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        })
    },
    mounted() {
        if (this.campaign.bot) {
            this.getBotList()

        } else {
            this.getAgentList()
        }
    },
    methods: {
        submit(event) {
            if (event) {
                event.preventDefault()
            }

            if (!this.formValid) {
                this.$refs.form.validate()
                return
            }

            if (lodash.isEqual(this.oldModel, this.model) && this.oldScript === this.currentScript.script) {
                this.$appService.toastInfo(this.$f.tc('nothingChanges'))
                return
            }

            this.updateCampaign()
        },
        updateCampaign() {
            this.$appService.showLoading()
            if (this.oldScript !== this.currentScript.script) {
                this.model.script = this.currentScript.script
            }
            this.$store.dispatch(this.$actionTypes.campaign.UPDATE_CAMPAIGN, {
                campaign: this.campaign,
                model: this.model
            }).then(() => {
                CampaignService.getCampaign(this.campaign.id).then(res => {
                    this.$store.dispatch(this.$actionTypes.campaign.SET_DATA, res.data).then(() => {
                        this.updateModel()
                    })
                })
            }).finally(() => {
                this.$appService.hideLoading()
            })
        },
        updateModel() {
            if (this.campaign?.bot) {
                this.typeOfScenario = 'bot'
                this.model.bot = this.campaign.bot.id
                this.model.title = this.campaign.title
                this.currentBotName = this.campaign.bot.name
            } else if (this.campaign?.tova_agent) {
                this.typeOfScenario = 'tova'
                this.model.title = this.campaign.title
                this.model.tova_agent = this.campaign.tova_agent.id
                this.currentTovaAgentName = this.campaign.tova_agent.name
            } else if (this.campaign?.agent_id) {
                this.typeOfScenario = 'agent'
                this.model.title = this.campaign.title
                this.model.agent_id = this.campaign.agent_id
                this.currentAgentId = this.campaign.agent_id
            } else if (this.campaign?.flow_id) {
                this.typeOfScenario = 'flow'
                this.model.title = this.campaign.title
                this.model.flow_id = this.campaign.flow_id
                this.currentFlowId = this.campaign.flow_id
            } else {
                this.model = this.$utils.cloneObject(defaultModel)
                this.currentBotName = ''
                this.currentTovaAgentName = ''
                this.currentAgentId = ''
                this.currentFlowId = ''
            }
            this.currentScript = this.campaign.freeswitch_scripts.find(script => script.script === this.campaign.script)
            this.oldScript = this.campaign.script
            this.oldModel = this.$utils.cloneObject(this.model)
        },
        getBotList() {
            this.$appService.showLoading()
            ScenarioService.search({page: 1, page_size: 1000}).then(
                result => {
                    this.scenarioList = result.data.data
                    this.botList = this.scenarioList.map(item => ({text: item.name, value: item.id}))
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: this.$t('nlp')
                }))
            ).finally(this.$appService.hideLoading)
        },
        getAgentList() {
            this.$appService.showLoading()
            AgentService.CRUD.search({page: 1, page_size: 1000}).then(
                result => {
                    this.tovaAgentList = result.data.data.map(item => ({text: item.name, value: item.id}))
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: this.$t('tova')
                }))
            ).finally(this.$appService.hideLoading)
        },
        goToScenario(id) {
            window.open(this.$router.resolve(`/scenarios/${id}`).href)
        },
        goToNLP(scenarioId) {
            let bot = this.scenarioList.find(scenario => scenario.id === scenarioId)
            if (bot) {
                let botHost = process.env.VUE_APP_BOT_HOST || 'https://bot.fpt.ai'
                window.open(`${botHost}/bot/${bot.nlp.code}`)
            } else {
                this.$appService.toastError('You don not have permission to access this bot')
            }
        },
        goToTovaAgent(id) {
            window.open(this.$router.resolve(`/agents/${id}`).href)
        },
        goToVoiceAgent(id) {
            let agentHost = process.env.VUE_APP_AGENT_END_POINT
            window.open(`${agentHost}/agent/${id}`)
        },
        goToFlow(id) {
            let agentHost = process.env.VUE_APP_AGENT_END_POINT
            window.open(`${agentHost}/${id}`)
        }
    },
    watch: {
        campaign: {
            deep: true,
            handler: 'updateModel'
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .v-slider__thumb-label {
        border-radius: 50% 50% 0;
        transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 0;
        top: 10px;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}

.title-config {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.label {
    font-family: "open sans semi", serif;
    margin-bottom: 6px;
    font-size: 13px;
}


.config-content {
    padding: 20px;
}

.btn-checkout {
    background: #FFFFFF;
    border: 1px solid #0052CC;
    color: #0052cc;
    margin-left: 8px;

    &:hover {
        background: #d9e5f7;
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-text-field__details {
            right: 20px;
        }
    }
}
</style>
